var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"r-ipt common-flex common-align-center common-justify-between"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.config.label)),(_vm.config.must)?_c('span',{staticStyle:{"color":"red"}},[_vm._v("*")]):_vm._e()]),_vm._v(" "),_c('div',{staticStyle:{"font-size":"14px","font-weight":"700"}},[_vm._v(_vm._s(_vm.config.textvalue))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d5d52ee","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/r-text.vue
// module id = null
// module chunks = 